import React from 'react';
export function MarqueeBanner() {
  const text = '🔥 LANZAMIENTO ESPECIAL — 60% DE DESCUENTO — OFERTA POR TIEMPO LIMITADO 🔥';
  return <div className="w-full bg-gold text-white overflow-hidden py-2.5 relative z-50 shadow-md" data-id="element-118">
      <div className="flex whitespace-nowrap animate-marquee" data-id="element-119">
        {/* Duplicate text multiple times for seamless infinite scroll */}
        <span className="text-sm font-bold uppercase tracking-widest mx-4" data-id="element-120">
          {text}
        </span>
        <span className="text-sm font-bold uppercase tracking-widest mx-4" data-id="element-121">
          {text}
        </span>
        <span className="text-sm font-bold uppercase tracking-widest mx-4" data-id="element-122">
          {text}
        </span>
        <span className="text-sm font-bold uppercase tracking-widest mx-4" data-id="element-123">
          {text}
        </span>
        <span className="text-sm font-bold uppercase tracking-widest mx-4" data-id="element-124">
          {text}
        </span>
        <span className="text-sm font-bold uppercase tracking-widest mx-4" data-id="element-125">
          {text}
        </span>
      </div>
    </div>;
}